<template>
  <a-dialog v-model="show" max-width="800px" scrollable persistent>
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span> {{ $t("agenda.hAgendaDetails") }}</span>
          <v-progress-linear
            :active="loadingData"
            :indeterminate="loadingData"
            absolute
            bottom
            color="appMenu"
          >
          </v-progress-linear>
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
      <v-card-text style="min-height: 45vh">
        <v-container style="padding: 12px 0px 0px !important">
          <v-form ref="refAgendaForm" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" class="pt-0 pb-0">
                <a-text-field
                  class="textField"
                  v-model="agendaDetailForm.agendaName"
                  :label="$t('agenda.lblAgendaTitle')"
                  :requiredMessage="$t('agenda.ruleAgendaNameReq')"
                  :disabled="disabledValidation"
                  required
                  filled
                  color="neutralGray"
                ></a-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="pt-0 pb-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on">
                      <v-select
                        v-bind="attrs"
                        class="selectField"
                        ref="refCategory"
                        v-model="agendaDetailForm.category"
                        :items="categories"
                        :label="`${$t('agenda.hCategory')} *`"
                        dense
                        item-text="name"
                        item-value="name"
                        :rules="categoryRule"
                        required
                        return-object
                        :disabled="disabledValidation"
                        :menu-props="{
                          bottom: true,
                          offsetY: true,
                          closeOnContentClick: true,
                          closeOnClick: true,
                        }"
                        color="neutralGray"
                        filled
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ $t("agenda.NoMatchingCat") }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                          <span>{{ item.name }}</span>
                        </template>
                      </v-select>
                    </div>
                  </template>
                  <span>{{ $t("agenda.tipAgendaCategoryField") }} </span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="6" class="pt-0 pb-0" v-if="false">
                <div
                  v-if="hasCalledFromMeeting || disabledValidation"
                  class="meeting-type-label"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div>{{ $t("agenda.captionMeetingType") }}</div>
                      <br />
                      <span v-bind="attrs" v-on="on">{{
                        agendaDetailForm.meetingType.label
                      }}</span>
                    </template>
                    <span v-html="$t('agenda.tipMeetingTypeField')"></span>
                  </v-tooltip>
                </div>
                <div v-else>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on">
                        <v-select
                          v-bind="attrs"
                          class="selectField"
                          ref="refMeetingType"
                          v-model="agendaDetailForm.meetingType"
                          :items="meetingTypes"
                          :label="`${$t('agenda.lblMeetingType')} *`"
                          dense
                          item-text="label"
                          item-value="label"
                          :rules="meetingTypeRule"
                          required
                          return-object
                          :menu-props="{ bottom: true, offsetY: true }"
                          :disabled="hasCalledFromMeeting || disabledValidation"
                          color="neutralGray"
                          filled
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ $t("agenda.NoMatchingMeetType") }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                          <template v-slot:item="{ item }">
                            <span>{{ item.label }}</span>
                          </template>
                        </v-select>
                      </div>
                    </template>
                    <span v-html="$t('agenda.tipMeetingTypeField')"></span>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="pt-0 pb-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on">
                      <v-select
                        v-bind="attrs"
                        class="selectField"
                        v-model="agendaDetailForm.frequency"
                        :items="frequencies"
                        :label="`${$t('agenda.hFrequency')} *`"
                        dense
                        color="neutralGray"
                        filled
                        :rules="[(v) => !!v || $t('agenda.ruleFreqReq')]"
                        required
                        :menu-props="{ bottom: true, offsetY: true }"
                        :disabled="disabledValidation"
                      ></v-select>
                    </div>
                  </template>
                  <span>{{ $t("agenda.tipFrequencyField") }} </span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" class="pt-0 pb-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on">
                      <v-select
                        v-bind="attrs"
                        class="selectField"
                        v-model="agendaDetailForm.priority"
                        :items="priorities"
                        :label="`${$t('agenda.hPriority')} *`"
                        dense
                        color="neutralGray"
                        filled
                        :rules="[(v) => !!v || $t('agenda.rulePriorityReq')]"
                        required
                        :menu-props="{ bottom: true, offsetY: true }"
                        :disabled="disabledValidation"
                      ></v-select>
                    </div>
                  </template>
                  <span>{{ $t("agenda.tipPriorityField") }} </span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-0 pb-0">
                <h4>{{ $t("Topics") }} *</h4>
                <v-list dense>
                  <template v-for="topicItem in agendaDetailForm.topics">
                    <div v-if="!topicItem.is_archived" :key="`tlist${topicItem.topicName}`">
                      <v-row
                          v-if="topicItem.Id === editTopicId"
                          no-gutters
                        >
                      <v-card flat>
                        <v-card-text class="px-0 py-0">
                          <v-form
                            ref="topicForm"
                            v-model="valid"
                            lazy-validation
                          >
                            <add-agenda-topic-details
                              v-model="topic"
                              @saveTopic="saveEditTopicDetails"
                              @cancel="onCancelAddTopic"
                              :agendaDetail="agendaDetailForm"
                              :oldTopicName="oldTopicName"
                              :archivedTopics="meetingValidation.topic_names"
                              :isInline="true"
                            ></add-agenda-topic-details>
                          </v-form>
                        </v-card-text>
                      </v-card>
                    </v-row>
                    <v-list-item
                      v-else
                      :key="`tlist${topicItem.topicName}`"
                      class="pa-0"
                    >
                      <v-avatar tile size="25">
                        <v-icon>mdi-card-text-outline</v-icon>
                      </v-avatar>
                      <v-row no-gutters>
                        <v-col cols="12" sm="10">
                          <v-list-item-content class="pl-3">
                            <v-row no-gutters>
                              <v-col
                                cols="12"
                                sm="6"
                                style="line-height: 30px; overflow-wrap: anywhere;"
                                md="6"
                                class="ma-0 pa-0"
                              >
                                {{ topicItem.topicName }}
                              </v-col>
                              <v-col
                                cols="12"
                                sm="4"
                                md="4"
                                class="ma-0 pt-1 pb-0"
                              >
                                <a-chip small label outlined class="minute ml-2">{{
                                  getTopicCategory(topicItem.topicCategory)
                                }}</a-chip>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="2"
                                md="2"
                                class="ma-0 pt-1 pb-0"
                              >
                                <a-chip small outlined class="minute"
                                  >{{ topicItem.timeInMinutes }} min</a-chip
                                >
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-col>
                        <v-col cols="12" sm="2" class="text-right">
                          <v-list-item-action class="mr-0">
                            <div>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-on="on" class="float-left">
                                    <a-btn
                                      :disabled="!isTopicDisabled(topicItem.Id)"
                                      v-bind="attrs"
                                      x-small
                                      @click="editAgendaTopic(topicItem)"
                                      color="primaryDark"
                                      elevation="1"
                                      width="24"
                                      min-width="24"
                                    >
                                      <v-icon size="16"> mdi-pencil </v-icon>
                                    </a-btn>
                                  </div>
                                </template>
                                <span v-if="isTopicDisabled(topicItem.Id)"
                                  >{{ $t("agenda.tipEditTopic") }}
                                </span>
                                <span v-else
                                  >{{ $t("agenda.tipDisableDeleteTopic") }}
                                </span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-on="on" class="float-left">
                                    <a-btn
                                      :disabled="!isTopicDisabled(topicItem.Id)"
                                      class="ml-3"
                                      v-bind="attrs"
                                      x-small
                                      @click="deleteAgendaTopic(topicItem)"
                                      width="24"
                                      min-width="24"
                                      color="primaryDark"
                                      elevation="1"
                                    >
                                      <v-icon size="16">mdi-delete</v-icon>
                                    </a-btn>
                                  </div>
                                </template>
                                <span v-if="isTopicDisabled(topicItem.Id)"
                                  >{{ $t("agenda.tipDeleteTopic") }}
                                </span>
                                <span v-else
                                  >{{ $t("agenda.tipDisableDeleteTopic") }}
                                </span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="isTopicArchive(topicItem.Id)">
                                <template v-slot:activator="{ on, attrs }">
                                  <a-btn
                                    v-if="isTopicArchive(topicItem.Id)"
                                    class="ml-3"
                                    v-bind="attrs"
                                    v-on="on"
                                    x-small
                                    width="24"
                                    min-width="24"
                                    color="primaryDark"
                                    elevation="1"
                                    @click="archiveTopic(topicItem.Id)"
                                  >
                                    <v-icon size="16">mdi-package-down</v-icon>
                                  </a-btn>
                                </template>
                                <span>{{ $t("agenda.lblArchive") }} </span>
                              </v-tooltip>
                            </div>
                          </v-list-item-action>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    </div>
                  </template>
                </v-list>
                <v-tooltip bottom v-if="!showTopicPanle">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      text
                      color="primary"
                      @click.stop="openTopicDialog()"
                      class="ma-0 pa-0 mb-5"
                    >
                      <v-icon small>mdi-plus</v-icon
                      >{{ $t("agenda.btnAddTopic") }}
                    </v-btn>
                  </template>
                  <span> {{ $t("agenda.btnAddTopic") }} </span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" v-if="showTopicPanle">
                <v-card flat>
                  <v-card-text class="px-0 py-0">
                    <v-form ref="topicAddForm" v-model="valid" lazy-validation>
                      <add-agenda-topic-details
                        v-model="topic"
                        @saveTopic="saveNewTopicDetails"
                        @cancel="onCancelAddTopic"
                        :agendaDetail="agendaDetailForm"
                        :oldTopicName="oldTopicName"
                        :archivedTopics="meetingValidation.topic_names"
                        :isInline="true"
                      ></add-agenda-topic-details>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              color="primaryDark"
              class="mr-2"
              @click.stop="saveAgenda"
              :loading="loadingBtn"
              :disabled="isSaveDisabled"
            >
              {{ $t("btnSave") }}
            </a-btn>
          </template>
          <span> {{ $t("btnSave") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn v-on="on" v-bind="attrs" color="secondary" @click="close">{{
              $t("btnClose")
            }}</a-btn>
          </template>
          <span> {{ $t("btnClose") }} </span>
        </v-tooltip>
      </v-card-actions>
      <!-- Topic popup!-->
      <v-dialog
        v-model="topicDialog"
        v-if="topicDialog"
        persistent
        max-width="400px"
      >
        <v-card>
          <v-banner
            color="primaryLight1"
            dark
            height="50px"
            sticky
            single-line
            tile
          >
            <v-toolbar color="primaryLight1" dark height="30px">
              <span> {{ $t("agenda.lblNewTopic") }}</span>
              <v-progress-linear
                :active="loadingData"
                :indeterminate="loadingData"
                absolute
                bottom
                color="primaryLight1"
              >
              </v-progress-linear>
              <v-spacer></v-spacer>
              <v-icon @click="topicDialog = false" color="grey-lighten-1"
                >mdi-close</v-icon
              >
            </v-toolbar>
          </v-banner>
          <v-card-text class="pt-5 pb-0">
            <v-container style="padding: 0 !important">
              <v-form ref="refTopicForm" v-model="topicValid" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="12" class="pb-0">
                    <a-text-field
                      class="textField"
                      v-model="topic.topicName"
                      :label="$t('topic')"
                      :requiredMessage="$t('agenda.ruleTopicNameReq')"
                      required
                      :hide-details="isTopicNameExist"
                      filled
                    ></a-text-field>
                    <span
                      v-if="isTopicNameExist"
                      class="label-s"
                      style="color: var(--v-error-base) !important"
                      >{{ this.$t("agenda.msgTopicNameUnique") }}</span
                    >
                  </v-col>
                  <v-col cols="12" sm="12" class="pt-0 pb-0">
                    <v-select
                      class="selectField"
                      v-model="topic.topicCategory"
                      :items="topicCategories"
                      :label="`${$t('agenda.hCategory')} *`"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ bottom: true, offsetY: true }"
                      :rules="[(v) => !!v || $t('agenda.ruleCategoryNameReq')]"
                      required
                      filled
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" class="pt-0">
                    <v-text-field
                      class="textField"
                      v-model.trim.number="topic.timeInMinutes"
                      :label="$t('agenda.lblTimeInMin')"
                      type="number"
                      :min="0"
                      :max="9999"
                      :rules="[
                        (v) => validateTimeReqRule(v),
                        (v) => validateTimeLength(v),
                      ]"
                      required
                      :maxlength="timeDigitTextLimit"
                      pattern="/^-?\d+\.?\d*$/"
                      onKeyPress="if(this.value.length==maxLength) { return false; }"
                      @keydown="filterKey"
                      @input="filterNumberInput"
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <a-btn
              color="secondary"
              @click="topicDialog = false"
              style="padding-left: 10px"
              >{{ $t("btnCancel") }}
            </a-btn>
            <a-btn
              :disabled="isTopicNameExist"
              color="primaryDark"
              @click="saveTopic"
            >
              {{ $t("btnSave") }}
            </a-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
      <confirm-dialog ref="confirm" />
      <message-sheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></message-sheet>
      <prevent-confirmation
        :prevent="isPrevent"
        @save="saveAgenda"
        @discard="preventClose(true)"
        @cancel="preventClose(false)"
      >
      </prevent-confirmation>
      <prevent-navigation
        :prevent="isPrevent"
        @save="saveAgenda"
        @discard="$event.next()"
        @cancel="$event.next(false)"
      >
      </prevent-navigation>
    </v-card>
  </a-dialog>
</template>
<style scoped>
.textField {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
}
.textField > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}
.textField /deep/ .v-input__slot {
  min-height: 48px !important;
}
.textField /deep/ textarea {
  margin-top: 22px !important;
}
.textField /deep/ .v-label {
  line-height: 16px !important;
}
.selectField /deep/ .v-input__slot {
  min-height: 48px !important;
}
.selectField /deep/ .v-label {
  line-height: 16px !important;
}
.selectField {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
}
.v-text-field--filled {
  border-radius: 0px !important;
}
.fabButtonTooltip {
  border-radius: 50%;
  width: 1% !important;
  height: 35px !important;
  margin-top: 10%;
}
::v-deep .v-banner__wrapper {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  padding-left: 10px !important;
  padding-top: 2px !important;
  padding-bottom: 5px !important;
}
</style>
<script>
import Loader from "@/components/Loader.vue";
import ColorSelector from "@/components/ColorSelector.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { createUUID } from "../../utils/util";
import ConfirmDialog from "../ConfirmDialog.vue";
import MessageSheet from "../MessageSheet.vue";
import PreventConfirmation from "@/components/PreventConfirmation.vue";
import PreventNavigation from "@/components/PreventNavigation.vue";
import _ from "lodash";
import { timeDigitTextLimit } from "../../utils/constant";
import agendaService from "../../api/agendaService";
import AddAgendaTopicDetails from "./AddAgendaTopicDetails.vue";
import SignalRMixin from "../../mixin/SignalRMixin";

export default {
  name: "AgendaPage",
  mixins: [SignalRMixin],
  data() {
    return {
      editTopicId: "",
      valid: true,
      showTopicPanle: false,
      specialCharRegex:
        /^[一-龠ぁ-ゔァ-ヴーa-zA-Zａ-ｚＡ-Ｚ々〆〤][一-龠ぁ-ゔァ-ヴーa-zA-Zａ-ｚＡ-Ｚ0-9々〆〤 ]*$/,
      timeDigitTextLimit: timeDigitTextLimit,
      oldTopicName: "",
      regexLatter: /[a-zA-Z]/,
      requiredAgendaRules: [
        (v) => !!v.trim() || this.$t("agenda.ruleAgendaNameReq"),
      ],
      categoryRule: [
        (v) => !!v || this.$t("agenda.ruleCategoryNameReq"),
        (v) => this.checkExist(v) || this.$t("agenda.ruleCategoryNameReq"),
      ],
      meetingTypeRule: [
        (v) => !!v || this.$t("agenda.ruleMeetingTypeReq"),
        (v) =>
          this.checMeetingTypekExist(v) || this.$t("agenda.ruleMeetingTypeReq"),
      ],
      Loaderloading: false,
      displayMessage: false,
      messageType: "",
      message: "",
      meetingTypeAlert: false,
      categoryValidation: false,
      topicValid: false,
      editMeetingTypeLabel: null,
      loadingData: false,
      loadingBtn: false,
      calmenu: false,
      valid: false,
      menu1: false,
      menu2: false,
      requiredRules: [(v) => this.valid || "Enter valid due date."],
      topicDialog: false,
      isPrevent: false,
      refNewTopicForm: {
        Id: "",
        agendaId: null,
        topicName: "",
        timeInMinutes: 0,
        topicCategory: "",
        actualTime: 0,
        peopleInCharge: [],
        documents: [],
        action: "",
        is_archived: false,
        memoDescription: ""
      },
      topic: {},
      agData: {},
      isDirty: false,
      agendaDetailForm: {
        id: this.agendaObject?.id ?? "",
        tenantid: this.agendaObject.tenantid,
        agendaName: this.agendaObject?.agendaName ?? "",
        category: this.agendaObject?.category ?? "",
        meetingType: this.agendaObject?.meetingType ?? {},
        priority: this.agendaObject?.priority ?? "",
        frequency: this.agendaObject?.frequency ?? "",
        memo: this.agendaObject?.memo ?? "",
        topics: _.cloneDeep(this.agendaObject?.topics) ?? [],
      },
      meetingValidation: {},
      disabledValidation: false,
    };
  },
  components: {
    ColorSelector,
    ConfirmDialog,
    MessageSheet,
    PreventConfirmation,
    PreventNavigation,
    Loader,
    AddAgendaTopicDetails,
  },
  props: {
    agendaObject: Object,
    value: {
      type: Boolean,
      default: false,
    },
    hasCalledFromMeeting: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    if (this.agendaObject && this.agendaObject.id) {
      this.Loaderloading = true;
      try {
        const result = await agendaService.getAgendaValidation(
          this.agendaObject.id
        );
        this.Loaderloading = false;
        if (result.past == true) {
          this.disabledValidation = true;
        }
        this.meetingValidation = result;
      } catch (error) {
        console.error(error);
        this.Loaderloading = false;
      }
    }
  },
  mounted() {
    this.signalRInit(`tenant_config_${this.selectedTenant}`);
    this.agData = this.agendaObject;
    this.agendaDetailForm.frequency = this.agendaObject?.frequency
      ? this.agendaObject.frequency
      : "Adhoc";
  },
  watch: {
    agendaObject(value) {
      if (!this.$refs.refAgendaForm) {
        return;
      }
      if (!this.agendaObject.id) {
        this.$refs.refAgendaForm.resetValidation();
        this.$refs.refAgendaForm.reset();
      }
      //this.agData = value
    },
    agendaDetailForm: {
      handler() {
        // here having access to the new and old value
        // if(this.$refs.refAgendaForm){
        //   this.$refs.refAgendaForm.inputs.forEach(e => {
        //     if(e.label != "Meeting Type" && e.isDirty){
        //       this.isDirty = true
        //       return false;
        //     }
        //   })
        // }

        this.isDirty = true;
      },
      deep: true,
    },
  },
  computed: {
    topicCategories() {
      return this.tenantSettingTypes("topiccategory");
    },
    priorities() {
      return [
        {
          text: this.$t("agenda.lblHigh"),
          value: "High",
        },
        {
          text: this.$t("agenda.lblMedium"),
          value: "Medium",
        },
        {
          text: this.$t("agenda.lblLow"),
          value: "Low",
        },
      ];
    },
    frequencies() {
      return [
        {
          text: this.$t("agenda.lblAnnually"),
          value: "Annually",
        },
        {
          text: this.$t("agenda.lblQuarterly"),
          value: "Quarterly",
        },
        {
          text: this.$t("agenda.lblMonthly"),
          value: "Monthly",
        },
        {
          text: this.$t("agenda.lblAdhoc"),
          value: "Adhoc",
        },
      ];
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    ...gettersMap(),
    ...statesMap(),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    selectedLang() {
      return localStorage.getItem("Lang#" + this.selectedTenant);
    },
    topicCat() {
      return "";
    },
    selectedTopicCategory: {
      get() {
        const data = [this.topic.topicCategory].map((value) =>
          this.topicCategories.find((option) => option.id === value)
        );
        return data.length ? data[0] : { text: "Approval", value: "A" };
      },
      set(value) {
        if (value) {
          this.topic.topicCategory = value.value;
        }
      },
    },
    isTopicNameExist() {
      const isExist =
        String(this.oldTopicName).toLowerCase().trim() !==
          String(this.topic.topicName).trim().toLowerCase() &&
        this.agendaDetailForm.topics.some(
          (t) =>
            String(t.topicName).toLowerCase().trim() ===
            String(this.topic.topicName).trim().toLowerCase()
        );
      return isExist;
    },
    isSaveDisabled() {
      let isSaveDisabled = true;
      if (this.isDirty) {
        isSaveDisabled = false;
      }
      if (this.showTopicPanle || this.editTopicId !== "") {
        isSaveDisabled = true;
      }
      return isSaveDisabled;
    },
    unarchiveTopicList: {
      get() {
        return this.agendaDetailForm.topics.filter(topic => !topic.is_archived);
      },
      set(val) {
        this.agendaDetailForm.topics = val;
      },
    },
    
  },
  methods: {
    ...mapActions({
      createTenantConfig: "tenant/createTenantConfig",
      updateTenantConfig: "tenant/updateTenantConfig",
      createAgendaData: "agenda/createAgenda",
      updateAgendaData: "agenda/updateAgenda",
      getTenantConfigList: "tenant/getUpdatedTenantConfigList",
    }),
    createUUID,
    saveAgenda,
    saveTopic,
    deleteAgendaTopic,
    editAgendaTopic,
    checkDuplicateItem,
    saveValidateAgenda,
    saveNewTopicDetails,
    onCancelAddTopic,
    saveTopicDetails,
    saveEditTopicDetails,
    signalRInit,
    cancelCategoryDialog() {
      this.categoryAlert = false;
      this.resetCategory();
    },
    cancelMeetingDialog() {
      this.meetingTypeAlert = false;
      this.resetMeetingType();
    },
    save() {},
    isTopicArchive(topicId){
      const existingTopics = _.cloneDeep(this.agendaObject?.topics);
      return existingTopics.some(item => item.Id === topicId);

    },
    isTopicDisabled(topic) {
      if (
        this.meetingValidation &&
        this.meetingValidation.past_topics &&
        this.meetingValidation.past_topics.length > 0
      ) {
        if (this.meetingValidation.past_topics.includes(topic)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    openTopicDialog() {
      this.showTopicPanle = true;
      this.topic = _.cloneDeep(this.refNewTopicForm);
      this.topic.action = "add";
      if (this.topicCategories && this.topicCategories.length) {
        this.topic.topicCategory = _.cloneDeep(this.topicCategories[0].id);
      }
      this.editTopicId = "";
      this.oldTopicName = "";
    },
    close() {
      if (this.isDirty == true) {
        this.isPrevent = true;
      } else {
        this.$emit("input", false);
      }
    },
    preventClose(status) {
      this.isPrevent = false;
      if (status == true) {
        this.$emit("input", false);
        this.isDirty = false;
      }
    },
    archiveTopic(topicId){
      const topic = this.agendaDetailForm.topics.map(topic => (topic.Id === topicId ? { ...topic, is_archived: true } : topic));
      this.agendaDetailForm.topics = topic;
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    getFileIcon(filename) {
      var filetype = filename.split(".")[1];
      switch (filetype) {
        case "pdf":
          return require("@/assets/icons/PDFFileNN.png");
        case "ppt":
        case "pptx":
          return require("@/assets/icons/PPT.png");
        case "doc":
        case "docx":
          return require("@/assets/icons/Docx.png");
      }
      return require("@/assets/icons/Docx.png");
    },
    async ConfirmDelete() {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.hDeleteMessage"),
          this.$t("agenda.lblDeleteMessage")
        )
      ) {
        return true;
      }
    },
    validateTimeLength(value) {
      return (
        (value !== null && value.toString().length < 5) ||
        this.$t("agenda.ruleTimeMaxlength")
      );
    },
    validateTimeReqRule(value) {
      return (
        (value.toString() !== "" && Number(value) > -1) ||
        this.$t("agenda.ruleTimeReq")
      );
    },
    filterKey(e) {
      const key = e.key;
      if (key === ".") return e.preventDefault();
      if (key === "e") return e.preventDefault();
      if (key === "-") return e.preventDefault();
    },
    filterNumberInput(e) {
      if (this.topic.timeInMinutes) {
        let filtered = this.topic.timeInMinutes
          .toString()
          .replace(/[^0-9]+/g, "");

        filtered = filtered.replace(/^0+/, "");

        this.topic.timeInMinutes = filtered ? filtered : "0";
      } else {
        this.topic.timeInMinutes = "0";
      }
    },
    removeWhiteSpace(text) {
      return text.replace(/[\s\/]/g, "");
    },
    onlyLettersRequired() {
      const regex = "/^[A-Za-z0-9]*$/";
      return /[a-zA-Z]/.test(this.agendaObject.agendaName);
    },
    checkExist(item) {
      if (item.name) {
        const exist =
          this.categories.findIndex((v) => v.name === item.name) !== -1;
        return exist;
      } else {
        return true;
      }
    },
    checMeetingTypekExist(item) {
      if (item.label) {
        const exist =
          this.meetingTypes.findIndex((v) => v.label === item.label) !== -1;
        return exist;
      } else {
        return true;
      }
    },
    getTopicCategory(topCat) {
      const category = this.topicCategories.find((c) => c.id === topCat) || {
        name: "",
        value: "",
        id: "",
      };
      return category.name;
    },
    isTopicDirty(){
      const existingTopics = _.cloneDeep(this.agendaObject?.topics);
      if(existingTopics.length !== this.agendaDetailForm.topics.length){
        return true;
      }

      const existingResult = existingTopics.map(item => ({
        agendaId: item.agendaId,
        topicName: item.topicName,
        timeInMinutes: Number(item.timeInMinutes),
        topicCategory: item.topicCategory
      })).sort((a, b) => a.topicName.localeCompare(b.topicName));

      const updatedResult = this.agendaDetailForm.topics.map(item => ({
        agendaId: item.agendaId,
        topicName: item.topicName,
        timeInMinutes: Number(item.timeInMinutes),
        topicCategory: item.topicCategory
      })).sort((a, b) => a.topicName.localeCompare(b.topicName));

      return JSON.stringify(existingResult) !== JSON.stringify(updatedResult);
    }
  },
};

async function signalRInit(target) {
  await this.signalConnection.on(target, async (message) => {
    const config_name = message.config_name || "";
    if (config_name === "topiccategory" || config_name === "category") {
      await this.getTenantConfigList();
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function editAgendaTopic(item) {
  this.showTopicPanle = false;
  this.topic = Object.assign({}, item);
  this.topic.action = "edit"
  this.editTopicId = this.topic.Id;
  this.oldTopicName = Object.assign({}, item).topicName;
  // this.topicDialog = true;
  // this.showTopicPanle = true;
}

async function deleteAgendaTopic(item) {
  const answer = await this.ConfirmDelete();
  if (answer) {
    const { topics } = this.agendaDetailForm;
    this.agendaDetailForm.topics = topics.filter(
      (type) => type.topicName != item.topicName
    );
  }
}

function onCancelAddTopic() {
  this.showTopicPanle = false;
  this.topic = _.cloneDeep(this.refNewTopicForm);
  this.editTopicId = "";
  // this.expandedRow.pop();
  // this.newTopicForm = cloneDeep(this.refNewTopicForm);
}

function saveTopicDetails(topicData) {
  if (topicData.timeInMinutes) {
    topicData.timeInMinutes = parseInt(topicData.timeInMinutes.toString());
  }
  if (topicData.Id) {
    let topicIndex = this.agendaDetailForm.topics.findIndex(
      (f) => f.Id === topicData.Id
    );
    if (topicIndex != -1) {
      if (
        JSON.stringify(this.agendaDetailForm.topics[topicIndex]) !==
        JSON.stringify(topicData)
      ) {
        this.isDirty = true;
      }
      this.agendaDetailForm.topics[topicIndex] = topicData;
    }
  } else {
    topicData.agendaId = this.agendaDetailForm.id;
    topicData.Id = createUUID();
    this.agendaDetailForm.topics.push(topicData);
  }
  this.onCancelAddTopic();
}

async function saveNewTopicDetails() {
  const topicData = this.topic;
  if (this.$refs.topicAddForm.validate()) {
    this.saveTopicDetails(topicData);
  }
}

function saveEditTopicDetails() {
  const topicData = this.topic;
  if (this.$refs.topicForm[0].validate()) {
    this.saveTopicDetails(topicData);
  }
}

function saveTopic() {
  const topicData = this.topic;
  if (this.$refs.refTopicForm.validate()) {
    if (topicData.Id) {
      let topicIndex = this.agendaDetailForm.topics.findIndex(
        (f) => f.Id === topicData.Id
      );
      if (topicIndex != -1) {
        if (
          JSON.stringify(this.agendaDetailForm.topics[topicIndex]) !==
          JSON.stringify(topicData)
        ) {
          this.isDirty = true;
        }
        this.agendaDetailForm.topics[topicIndex] = topicData;
      }
    } else {
      topicData.agendaId = this.agendaDetailForm.id;
      topicData.Id = createUUID();
      this.agendaDetailForm.topics.push(topicData);
    }
    this.topicDialog = false;
    this.$refs.refTopicForm.resetValidation();
  }
}

async function saveValidateAgenda() {
  const archivedCount = this.agendaDetailForm.topics.filter(item => item.is_archived === true).length;
  this.isPrevent = false;
  if (
    this.$refs.refAgendaForm.validate() &&
    this.agendaDetailForm.meetingType.label != "" &&
    this.agendaDetailForm.category.name != ""
  ) {
    const agendaFormData = _.cloneDeep(this.agendaDetailForm);
    const topics = this.agendaDetailForm.topics
    agendaFormData.topics = topics
    if (agendaFormData.topics.length == 0) {
      this.showMessageSheet(this.$t("agenda.AddTopicsInfo"), "info");
      this.Loaderloading = false;
      return;
    }
    this.isDirty = false;
    if (agendaFormData.id) {
      agendaFormData.category = agendaFormData.category.name || "";
      agendaFormData.meetingTypeId = agendaFormData.meetingType.id || "";
      agendaFormData.meetingType = agendaFormData.meetingType.label || "";
      let requestData = _.cloneDeep(agendaFormData);
      requestData.topics = requestData.topics.map(
        ({ action, ...rest }) => rest
      );
      await this.updateAgendaData(requestData)
        .then((response) => {
          this.isDirty = false;
          if (this.hasCalledFromMeeting) {
            this.$emit("onCreateAgenda", agendaFormData);
          }
          this.close();
          this.$emit("alert", this.$t("agenda.AgendaUpdateSuccess"), "success");
        })
        .catch((e) => {
          this.Loaderloading = false;
        })
        .finally(() => (this.Loaderloading = false));
    } else {
      const guidId = createUUID();
      agendaFormData.id = guidId;
      agendaFormData.category = agendaFormData.category.name || "";
      agendaFormData.documents = [];
      agendaFormData.topics = agendaFormData.topics.map((obj) => ({
        ...obj,
        agendaId: guidId,
      }));
      agendaFormData.meetingTypeId = agendaFormData.meetingType.id || "";
      agendaFormData.meetingType = agendaFormData.meetingType.label || "";
      let requestData = _.cloneDeep(agendaFormData);
      requestData.topics = requestData.topics.map(
        ({ action, ...rest }) => rest
      );
      await this.createAgendaData(requestData)
        .then((response) => {
          this.isDirty = false;
          if (this.hasCalledFromMeeting) {
            this.$emit("onCreateAgenda", agendaFormData);
          }
          this.close();
          this.$emit("alert", this.$t("agenda.AgendaCreateSuccess"), "success");
        })
        .catch((e) => {
          this.Loaderloading = false;
        })
        .finally(() => (this.Loaderloading = false));
    }
  }else if(this.agendaDetailForm.category.name === ""){
    let message = this.$t("agenda.AddTopicsDataIssue");
    if(archivedCount === 0){
      message = this.$t("agenda.AddTopicsDataSaveIssue")
    }
    if(this.agendaObject.id != ""){
      this.showMessageSheet(message, "info");
    }
  }
}

async function saveAgenda() {
  const archivedCount = this.agendaDetailForm.topics.filter(item => item.is_archived === true).length;
  if (
    this.meetingValidation &&
    this.meetingValidation.future &&
    this.meetingValidation.future == true
  ) {
      if(archivedCount > 0 && !this.isTopicDirty()){
        await this.saveValidateAgenda();
        return
      }
    if (
      await this.$refs.confirm.open(
        this.$t("lblConfirm"),
        this.$t("agenda.msgAgendaUpdateMeetings"),
        {
          removeAgreeBtn: false,
        }
      )
    ) {
      await this.saveValidateAgenda();
    }
  } else {
    await this.saveValidateAgenda();
  }
}

function checkDuplicateItem(items, text, prop) {
  return items.some(
    (c) => String(c[prop]).toLowerCase() === String(text).toLowerCase()
  );
}

function gettersMap() {
  return mapGetters({
    categories: "tenant/agendaCategories",
    categoriesConfig: "tenant/agendaCategoryConfig",
    meetingTypes: "tenant/agendaMeetingTypes",
    meetingTypeConfig: "tenant/agendaMeetingTypeConfig",
    tenantSettingTypes: "tenant/tenantSettingTypes",
  });
}

function statesMap() {
  return mapState({
    tenantList: "tenant/tenantList",
  });
}
</script>
<style scoped>
.meeting-type-label {
  line-height: 22px;
}
</style>